import { FC, useMemo } from "react";

import { BaseModal } from "@/shared/ui/BaseModal";
import { SecondaryText } from "@/shared/ui/Typography";

import { SelfPlanModalState, SelfPlanModalType } from "../../types";
import { FinGroups } from "./components/FinGroups";
import { Products } from "./components/Products";
import { ProgressiveScale } from "./components/ProgressiveScale";
import { SequentialScale } from "./components/SequentialScale";

interface DashboardInfoModalProps {
    modalKey: string;
    isOpen: boolean;
    onClose: () => void;
    modalState: SelfPlanModalState | null;
}

export const DashboardInfoModal: FC<DashboardInfoModalProps> = ({
    modalKey,
    isOpen,
    onClose,
    modalState,
}) => {
    const content = useMemo(() => {
        if (!modalState) return null;

        switch (modalState.type) {
            case SelfPlanModalType.finGroups: {
                const { payload } = modalState;

                return <FinGroups finGroups={payload.finGroupDetails} />;
            }
            case SelfPlanModalType.progressiveScale: {
                const { payload } = modalState;

                return (
                    <ProgressiveScale
                        currentPercent={payload.currentPercent}
                        progressive={payload.progressive}
                    />
                );
            }
            case SelfPlanModalType.sequentialScale: {
                const { payload } = modalState;

                return (
                    <SequentialScale
                        minComplete={payload.minComplete}
                        maxComplete={payload.maxComplete}
                    />
                );
            }
            case SelfPlanModalType.products: {
                const { payload } = modalState;

                return <Products barcodes={payload.barcodes} />;
            }
            default:
                return null;
        }
    }, [modalState]);

    return (
        <BaseModal
            key={modalKey}
            open={isOpen}
            destroyOnHidden
            onClose={onClose}
            actions={null}
            title={modalState?.payload?.title ?? "Інформація"}
        >
            {content ?? <SecondaryText>Дані відсутні</SecondaryText>}
        </BaseModal>
    );
};
